import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Handshake } from "lucide-react";

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/mutual-funds", label: "Mutual Funds", id: "mutual-funds" },
  { to: "/insurance", label: "Insurance", id: "insurance" },
  { to: "/stock-brokers", label: "Brokers", id: "stock-brokers" },
  { to: "/real-estate", label: "Real Estate", id: "real-estate" },
  { to: "/markets", label: "Forex · Gold · Crypto", id: "markets" },
  { to: "/compare", label: "Compare", id: "compare" },
  { to: "/calculators", label: "Calculators", id: "calculators" },
];

const linkCls = ({ isActive }) =>
  `px-2.5 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors ${isActive ? "text-white bg-white/10" : "text-slate-300 hover:text-white hover:bg-white/5"}`;

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-navbar" className="sticky top-0 z-50 bg-[#0F172A] border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-6">
        <Link to="/" data-testid="nav-logo" className="shrink-0"><img src="/logo.png" alt="DhanTrove" className="h-8 lg:h-9 w-auto" /></Link>
        <nav className="hidden xl:flex items-center gap-1 flex-1">
          {NAV.map((n) => <NavLink key={n.id} to={n.to} end={n.to === "/"} data-testid={`nav-link-${n.id}`} className={linkCls}>{n.label}</NavLink>)}
        </nav>
        <Link to="/join-partner" data-testid="partner-join-button" className="hidden sm:inline-flex ml-auto xl:ml-0 items-center gap-2 h-10 px-4 rounded-lg bg-[#10B981] hover:bg-[#059669] text-[#0F172A] text-sm font-bold transition-colors">
          <Handshake className="w-4 h-4" /> Join as Partner
        </Link>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="xl:hidden ml-auto sm:ml-0 p-2 text-white" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="xl:hidden border-t border-white/10 px-4 py-3 grid gap-1 bg-[#0F172A]">
          {NAV.map((n) => <NavLink key={n.id} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${n.id}`} className={linkCls}>{n.label}</NavLink>)}
          <Link to="/join-partner" onClick={() => setOpen(false)} data-testid="nav-mobile-join" className="mt-2 h-11 rounded-lg bg-[#10B981] text-[#0F172A] font-bold flex items-center justify-center">Join as Partner</Link>
        </nav>
      )}
    </header>
  );
};
